import { BaseIcon } from './base';
import type { IconSmallProps } from './base';

export function IconAppExtraSmall(props: IconSmallProps) {
  return (
    <BaseIcon {...props} size={12} viewBox="0 0 12 12">
      <path
        d="M2.25 1.5C1.83579 1.5 1.5 1.83579 1.5 2.25V4.5C1.5 4.91421 1.83579 5.25 2.25 5.25H4.5C4.91421 5.25 5.25 4.91421 5.25 4.5V2.25C5.25 1.83579 4.91421 1.5 4.5 1.5H2.25ZM2.25 6.75C1.83579 6.75 1.5 7.08579 1.5 7.5V9.75C1.5 10.1642 1.83579 10.5 2.25 10.5H4.5C4.91421 10.5 5.25 10.1642 5.25 9.75V7.5C5.25 7.08579 4.91421 6.75 4.5 6.75H2.25ZM6.75 2.25C6.75 1.83579 7.08579 1.5 7.5 1.5H9.75C10.1642 1.5 10.5 1.83579 10.5 2.25V4.5C10.5 4.91421 10.1642 5.25 9.75 5.25H7.5C7.08579 5.25 6.75 4.91421 6.75 4.5V2.25ZM7.5 6.75C7.08579 6.75 6.75 7.08579 6.75 7.5V9.75C6.75 10.1642 7.08579 10.5 7.5 10.5H9.75C10.1642 10.5 10.5 10.1642 10.5 9.75V7.5C10.5 7.08579 10.1642 6.75 9.75 6.75H7.5Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
